import { StateCreator } from "zustand";
import type { SkyViewStore } from "~/features/skyView/store";
import { DEFAULT_ANNOTATION_COLOR } from "../types";

export interface PageAnnotationSlice {
  editingAnnotationId: string | null;
  activeAnnotationId: string | null;
  annotationColor: string;
  isAddingAnnotation: boolean;
  setEditingAnnotationId: (id: string | null) => void;
  setActiveAnnotationId: (id: string | null) => void;
  setAnnotationColor: (color: string) => void;
  setIsAddingAnnotation: (adding: boolean) => void;
  resetAnnotationState: () => void;
}

export const createPageAnnotationSlice: StateCreator<
  SkyViewStore,
  [["zustand/persist", unknown], ["zustand/immer", never]],
  [],
  PageAnnotationSlice
> = (set) => ({
  editingAnnotationId: null,
  activeAnnotationId: null,
  annotationColor: DEFAULT_ANNOTATION_COLOR,
  isAddingAnnotation: false,
  setEditingAnnotationId: (id: string | null) =>
    set(() => ({
      editingAnnotationId: id,
    })),
  setActiveAnnotationId: (id: string | null) =>
    set(() => ({
      activeAnnotationId: id,
    })),
  setAnnotationColor: (color: string) =>
    set(() => ({
      annotationColor: color,
    })),
  setIsAddingAnnotation: (adding: boolean) =>
    set(() => ({
      isAddingAnnotation: adding,
    })),
  resetAnnotationState: () =>
    set(() => ({
      editingAnnotationId: null,
      activeAnnotationId: null,
      isAddingAnnotation: false,
    })),
});
